module.exports = __webpack_public_path__ + "static/media/percent.d854dcc9.svg";